// extracted by mini-css-extract-plugin
module.exports = {"shareDrawer":"Share_shareDrawer__3GJco","shareItem":"Share_shareItem__2IPil"};